<mat-form-field appearance="outline" class="lang">
  <mat-label>{{ "app.redirect-dropdown-placeholder" | translate }}</mat-label>
  <mat-select
    [(ngModel)]="language" (ngModelChange)="onSelectLanguage()"
  >
    <mat-option [value]="lang.value" *ngFor="let lang of languages" class="lang__option">{{lang.title}}</mat-option>
  </mat-select>
</mat-form-field>
